import CartImage from "./components/cart/CartImage"

require("./storefront")

import Vue from "vue"
import BootstrapVue from "bootstrap-vue"
import { VueSelect } from "vue-select/src"
import vClickOutside from "v-click-outside"
import VueToast from "vue-toast-notification"
import { required, email, confirmed, required_if, integer, min, max, between, min_value } from "vee-validate/dist/rules"
import { ValidationProvider, ValidationObserver, extend } from "vee-validate"

import store from "./store"
import { notify, trans, chunk, errorNotify, successNotify } from "./functions"

import Level from "@core/components/rewards/Level"
import RewardIndex from "@core/components/rewards/Index"
import AccountOrders from "@core/components/orders/AccountOrders"

import QD from "./components/QD"
import CartIndex from "./components/cart/Index"
import BlogPage from "./components/blogs/BlogPage"
import BlogsList from "./components/blogs/BlogsList"
import ProductShow from "./components/products/Show"
import CompareIndex from "./components/compare/Index"
import CookieBar from "./components/layout/CookieBar"
import DynamicTab from "./components/home/DynamicTab"
import ProductIndex from "./components/products/Index"
import BlogsAside from "./components/blogs/BlogsAside"
import RecentBlogs from "./components/blogs/RecentBlogs"
import VPagination from "./components/VPagination.vue"
import AccountTap from "./components/account/tap/Index"
import AccountCards from "./components/account/cards/Index"
import TopBrands from "./components/home/TopBrands.vue"
import FlashSale from "./components/home/FlashSale.vue"
import CheckoutComplete from "./components/checkout/Complete.vue"
import CheckoutCreate from "./components/checkout/Create"
import SidebarCart from "./components/layout/SidebarCart"
import PopupCart from "./components/layout/PopupCart"
import NewProducts from "./components/home/NewProducts.vue"
import ProductGrid from "./components/home/ProductGrid.vue"
import Lookup from "./components/tap banknote/lookup/Lookup"
import MyWishlist from "./components/account/wishlist/Index"
import DailyDealTimer from "./components/DailyDealTimer.vue"
import AdminCreateOrder from "./components/cart/admin/Index"
import VideoSection from "./components/home/VideoSection.vue"
import HomeFeatures from "./components/home/HomeFeatures.vue"
import MyAddresses from "./components/account/addresses/Index"
import HeaderSearch from "./components/layout/HeaderSearch.vue"
import HeaderSM from "./components/layout/HeaderSM.vue"
import ProductTabsOne from "./components/home/ProductTabsOne.vue"
import ProductTabsTwo from "./components/home/ProductTabsTwo.vue"
import NewsletterPopup from "./components/layout/NewsletterPopup"
import LandscapeProducts from "./components/LandscapeProducts.vue"
import SearchResultsFor from "./components/SearchResultsFor"
import BannerOneColumn from "./components/home/BannerOneColumn.vue"
import BannerTwoColumn from "./components/home/BannerTwoColumn.vue"
import VerticalProducts from "./components/home/VerticalProducts.vue"
import ProductCardVertical from "./components/ProductCardVertical.vue"
import TransferOwnership from "./components/tap/TransferOwnership.vue"
import BannerThreeColumn from "./components/home/BannerThreeColumn.vue"
import ProfileDetails from "./components/account/profile/ProfileDetails"
import FeaturedCategories from "./components/home/FeaturedCategories.vue"
import Submissions from "./components/tap banknote/submissions/Submissions"
import RelatedProducts from "./components/products/show/RelatedProducts.vue"
import NewsletterSubscription from "./components/layout/NewsletterSubscription"
import RecommendedSupplies from "./components/products/show/RecommendedSupplies.vue"
import AccountTransferOwnership from "./components/account/transfer ownership/Index"
import EditablePrice from "./components/EditablePrice.vue"
import DailyDealInlineEditor from "./components/DailyDealInlineEditor.vue"
import ProductCardGridView from "./components/products/index/ProductCardGridView.vue"
import ProductCardListView from "./components/products/index/ProductCardListView.vue"
import BannerThreeColumnFullWidth from "./components/home/BannerThreeColumnFullWidth.vue"
import FlashSaleAndVerticalProducts from "./components/home/FlashSaleAndVerticalProducts.vue"
import { integerOnly } from "@core/config/integerOnly"
import CustomPage from "./components/pages/CustomPage.vue"
import ManualDiscount from "./components/cart/admin/ManualDiscount.vue"
import SellToUs from "./components/sell to us/Create.vue"
import { VueGoodTable } from "vue-good-table"
import DropZone from "@core/components/DropZone.vue"
import HeaderChart from "./components/layout/HeaderChart.vue"
Vue.prototype.route = route
Vue.prototype.$notify = notify
Vue.prototype.$successNotify = successNotify
Vue.prototype.$errorNotify = errorNotify
Vue.prototype.$trans = trans
Vue.prototype.$chunk = chunk

Vue.use(VueToast)
Vue.use(vClickOutside)
Vue.use(BootstrapVue)

Vue.component("qd", QD)
Vue.component("cart-image", CartImage)
Vue.component("level", Level)
Vue.component("lookup", Lookup)
Vue.component("v-select", VueSelect)
Vue.component("blog-page", BlogPage)
Vue.component("cart-index", CartIndex)
Vue.component("top-brands", TopBrands)
Vue.component("flash-sale", FlashSale)
Vue.component("cookie-bar", CookieBar)
Vue.component("blogs-list", BlogsList)
Vue.component("blogs-aside", BlogsAside)
Vue.component("recent-blogs", RecentBlogs)
Vue.component("my-wishlist", MyWishlist)
Vue.component("account-tap", AccountTap)
Vue.component("dynamic-tab", DynamicTab)
Vue.component("submissions", Submissions)
Vue.component("my-addresses", MyAddresses)
Vue.component("product-show", ProductShow)
Vue.component("v-pagination", VPagination)
Vue.component("product-grid", ProductGrid)
Vue.component("new-products", NewProducts)
Vue.component("sidebar-cart", SidebarCart)
Vue.component("popup-cart", PopupCart)
Vue.component("home-features", HomeFeatures)
Vue.component("header-search", HeaderSearch)
Vue.component("header-sm", HeaderSM)
Vue.component("video-section", VideoSection)
Vue.component("product-index", ProductIndex)
Vue.component("compare-index", CompareIndex)
Vue.component("account-rewards", RewardIndex)
Vue.component("account-orders", AccountOrders)
Vue.component("account-cards", AccountCards)

Vue.component("checkout-create", CheckoutCreate)
Vue.component("checkout-complete", CheckoutComplete)
Vue.component("profile-details", ProfileDetails)
Vue.component("product-tabs-one", ProductTabsOne)
Vue.component("daily-deal-timer", DailyDealTimer)
Vue.component("product-tabs-two", ProductTabsTwo)
Vue.component("newsletter-popup", NewsletterPopup)
Vue.component("related-products", RelatedProducts)
Vue.component("banner-one-column", BannerOneColumn)
Vue.component("banner-two-column", BannerTwoColumn)
Vue.component("vertical-products", VerticalProducts)
Vue.component("search-results-for", SearchResultsFor)
Vue.component("admin-create-order", AdminCreateOrder)
Vue.component("landscape-products", LandscapeProducts)
Vue.component("transfer-ownership", TransferOwnership)
Vue.component("ValidationProvider", ValidationProvider)
Vue.component("ValidationObserver", ValidationObserver)
Vue.component("banner-three-column", BannerThreeColumn)
Vue.component("featured-categories", FeaturedCategories)
Vue.component("recommended-supplies", RecommendedSupplies)
Vue.component("product-card-vertical", ProductCardVertical)
Vue.component("editable-price", EditablePrice)
Vue.component("daily-deal-inline-editor", DailyDealInlineEditor)
Vue.component("product-card-grid-view", ProductCardGridView)
Vue.component("product-card-list-view", ProductCardListView)
Vue.component("newsletter-subscription", NewsletterSubscription)
Vue.component("account-transfer-ownership", AccountTransferOwnership)
Vue.component("banner-three-column-full-width", BannerThreeColumnFullWidth)
Vue.component("flash-sale-and-vertical-products", FlashSaleAndVerticalProducts)
Vue.component("custom-page", CustomPage)
Vue.component("manual-discount", ManualDiscount)
Vue.component("sell-to-us", SellToUs)
Vue.component("drop-zone", DropZone)
Vue.component("header-chart", HeaderChart)

extend("required", { ...required, message: "The {_field_} field is required" })
extend("required_if", { ...required_if, message: "The {_field_} field is required" })
extend("email", { ...email })
extend("confirmed", { ...confirmed })
extend("integer", { ...integer })
extend("min", { ...min })
extend("max", { ...max })
extend("between", { ...between })
extend("min_value", { ...min_value })
extend("phone", {
  getMessage(field, args) {
    return `The ${field} must be a valid phone number`
  },
  validate(value, args) {
    // Custom regex for a phone number
    // (supplied in the SO post: https://stackoverflow.com/q/50033651/2600825)
    const MOBILEREG = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

    return MOBILEREG.test(value)
  }
})

Vue.directive("integer-only", integerOnly)

new Vue({
  el: "#app",
  store,
  computed: {
    cart() {
      return store.state.cart
    },
    wishlistCount() {
      return store.wishlistCount()
    }
  }
})

$.ajaxSetup({
  headers: {
    "X-CSRF-TOKEN": Trillion.csrfToken
  }
})
